import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const ansible = defineConnector({
  identifier: "ansible",
  name: "Ansible",
  tagLine: "IT automation platform",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your Ansible Automation Platform and generate an API token from your user profile settings.",
        },
      ],
    },
    {
      title: "Enter your instance URL and API token",
      items: [
        {
          kind: "url",
          label: "Instance URL",
          placeholder: "https://your-controller.example.com",
          required: true,
          target: { kind: "configuration", field: "instanceUrl" },
        },
        {
          kind: "input",
          label: "Ansible API token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/api/v2/ping/`,
  },
});
